import { render, staticRenderFns } from "./MinimalSubtitleFormatting.vue?vue&type=template&id=0cf763b2&scoped=true&"
import script from "./MinimalSubtitleFormatting.vue?vue&type=script&lang=js&"
export * from "./MinimalSubtitleFormatting.vue?vue&type=script&lang=js&"
import style0 from "./MinimalSubtitleFormatting.vue?vue&type=style&index=0&id=0cf763b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf763b2",
  null
  
)

export default component.exports